import React from 'react';
import './Download.css';
import googlePlay from '../assets/googlePlay.svg';
import appStore from '../assets/appStore.svg';
import { useTranslation } from 'react-i18next';

const Download: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="download" className="download">
      <div className="container">
        <div className="download-content">
          <div className="download-text">
            <h2 className="section-title">{t('download.title')}</h2>
            <p className="section-subtitle">
              {t('download.subtitle')}
            </p>
            
            <div className="download-buttons">
              <a href="https://apps.apple.com/app/foodquick-ai-recipe-generator/id6749247976" className="download-btn">
                <img src={appStore} alt="Download on the App Store" />
              </a>
              <a href="https://play.google.com/apps/testing/com.engdeveloper.FoodQuick" className="download-btn">
                <img src={googlePlay} alt="Get it on Google Play" />
              </a>
            </div>

           
          </div>
        </div>
      </div>
    </section>
  );
};

export default Download;
